import { MOVEMENTS } from "../../../constants";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";
import AddComplex from "../../../parts/modals/add-complex";
import AddOtherExerciseModal from "../../../parts/modals/add-other-exercise";
import AddSecondaryMovementModal from "../../../parts/modals/add-secondary-movement";
import ExerciseLibraryVideoModal from "../../../parts/modals/ExerciseLibraryVideoModal";
import EditPrimaryMovement from "../../../parts/modals/edit-primary-movement";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";
import { useRillContext } from "../../../rill/RillReact/share/base";
import ExerciseLibraryCoachComponent from "../../dashboard/settings/ExerciseLibraryCoachComponent";

function View() {
  const { locals } = useRillContext();

  const {
    query,
    activeUserToRequest,
    query: { type },
    complexes,
  } = locals;

  let primary = query.primary;

  if (type === "others") {
    primary = "assistant";
  }

  const secondaries =
    primary === "complex"
      ? complexes
      : activeUserToRequest.exerciseLibrary?.[primary]?.map((sec, index) => {
          return { ...sec, index, primary };
        });

  return (
    <ExerciseLibraryCoachComponent
      type={type}
      primary={primary}
      secondaries={secondaries}
      activeUserToRequest={activeUserToRequest}
    />
  );
}

const ExerciseLibraryController = async ({ res, req, locals, load }) => {
  const modal = req.query.modal || {};
  const { athlete, query, activeUserToRequest } = locals;
  const user = athlete || activeUserToRequest;
  const isNew = modal?.index === undefined || modal?.index === null;
  const libraryAssistant = user.exerciseLibrary?.assistant || [];
  const indexAssistant = modal?.index ?? libraryAssistant.length;
  const primary = modal?.primary || "squat";
  const library = user.exerciseLibrary?.[primary] || [];
  const index = modal?.index ?? library.length;
  const modalIndex = locals.query?.modal?.index;
  const intensityMeasure =
    activeUserToRequest.intensityMeasure === "rpe" ? "RPE" : "RiR";
  const isRiR = intensityMeasure === "RiR";

  let exercise =
    modalIndex > -1
      ? library[modalIndex]
      : {
          movement: MOVEMENTS[primary],
          primary,
          ...activeUserToRequest.primaryExercises?.[primary],
        };
  let complex;
  if (query.primary === "complex") {
    await load("complexes");
    complex = locals.complexes.find(({ _id }) => _id === query.complex);
    exercise = complex;
  }

  locals.modal = {
    "add-secondary-movement": (
      <AddSecondaryMovementModal
        isNew={isNew}
        library={library}
        index={index}
        athlete={athlete}
        primary={primary}
        user={activeUserToRequest}
      />
    ),
    "edit-primary-movement": (
      <EditPrimaryMovement
        query={locals.query}
        activeUserToRequest={activeUserToRequest}
        athlete={locals.athlete}
      />
    ),
    "add-other-exercise": (
      <AddOtherExerciseModal
        isNew={isNew}
        library={libraryAssistant}
        index={indexAssistant}
        athlete={athlete}
        intensityMeasure={intensityMeasure}
        isRiR={isRiR}
      />
    ),
    "exercise-library-video": (
      <ExerciseLibraryVideoModal
        exercise={exercise}
        athleteId={user._id}
        primary={primary}
      />
    ),
    "exercise-set-video": (
      <JWPlayerVideoModal
        mediaId={query.mediaId}
        setNumber={query.setNumber}
        setTarget={query.setTarget}
        setComment={query.setComment}
      />
    ),
    "activity-feed": <ActivityDrawer />,
    "add-complex": (
      <AddComplex complex={complex} exerciseLibrary={user.exerciseLibrary} />
    ),
  }[modal.type];

  req.query.primary ||= "assistant";
  req.query.type ||= "powerlifting";
  res.body = <View />;
};

export default ExerciseLibraryController;
